var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "close-on-click-modal": false,
        width: "640px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.cancleBtn,
      },
    },
    [
      _vm.isEdit
        ? _c(
            "el-form",
            {
              ref: "empForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.employeeForm,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "员工姓名：", prop: "userName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.employeeForm.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.employeeForm, "userName", $$v)
                      },
                      expression: "employeeForm.userName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "员工账号：", prop: "userCode" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.vstatus },
                    model: {
                      value: _vm.employeeForm.userCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.employeeForm, "userCode", $$v)
                      },
                      expression: "employeeForm.userCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "其他联系方式：", prop: "contact" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50", "show-word-limit": "" },
                    model: {
                      value: _vm.employeeForm.contact,
                      callback: function ($$v) {
                        _vm.$set(_vm.employeeForm, "contact", $$v)
                      },
                      expression: "employeeForm.contact",
                    },
                  }),
                ],
                1
              ),
              _vm.vstatus
                ? _c(
                    "el-form-item",
                    { attrs: { label: "状态：", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.employeeForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.employeeForm, "status", $$v)
                            },
                            expression: "employeeForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("启用"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("停用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "可查看权限：", prop: "userRoles" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { indeterminate: _vm.isIndeterminate },
                      on: { change: _vm.handleCheckAllChange },
                      model: {
                        value: _vm.checkAll,
                        callback: function ($$v) {
                          _vm.checkAll = $$v
                        },
                        expression: "checkAll",
                      },
                    },
                    [_vm._v(" 全选 ")]
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckedCitiesChange },
                      model: {
                        value: _vm.employeeForm.userRoles,
                        callback: function ($$v) {
                          _vm.$set(_vm.employeeForm, "userRoles", $$v)
                        },
                        expression: "employeeForm.userRoles",
                      },
                    },
                    _vm._l(_vm.userRoles, function (item, index) {
                      return _c(
                        "el-checkbox",
                        {
                          key: index,
                          attrs: { label: item.id, name: "userRoles" },
                        },
                        [_vm._v(" " + _vm._s(item.roleName) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "label",
                { attrs: { for: "remark" } },
                [
                  _c("span", { staticStyle: { "vertical-align": "top" } }, [
                    _vm._v("备注："),
                  ]),
                  _c("el-input", {
                    attrs: {
                      id: "remark",
                      type: "textarea",
                      rows: 6,
                      resize: "none",
                      maxlength: "225",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.employeeForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.employeeForm, "remark", $$v)
                      },
                      expression: "employeeForm.remark",
                    },
                  }),
                ],
                1
              ),
              _c("p", { staticClass: "formTip" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _c("span", [_vm._v("保存后对方手机将收到通知")]),
              ]),
              _c(
                "el-form-item",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "dialogBtn",
                      attrs: { size: "medium" },
                      on: { click: _vm.cancleBtn },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "dialogBtn",
                      attrs: {
                        type: "primary",
                        size: "medium",
                        icon: _vm.btnLoading ? "el-icon-loading" : "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("empForm")
                        },
                      },
                    },
                    [_vm._v(" 确认 ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }